import React from 'react'

interface HeroProps {
  onCTAClick: () => void
}

export default function Hero({ onCTAClick }: HeroProps) {
  return (
    <section className="relative bg-gradient-to-br from-[#006B3F] via-[#003D23] to-[#001d11] text-white pt-16 pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <div className="inline-block bg-[#FDB913] text-[#003D23] px-4 py-2 rounded-full text-sm font-bold mb-6">
          📚 Material Base Petrobras
        </div>
        
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          O conteúdo estrutural que cai em qualquer edital da Petrobras
        </h1>
        
        <p className="text-xl text-gray-200 mb-8">
          Quem começa a estudar só depois do edital já está atrasado.
        </p>
      </div>
    </section>
  )
}